var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ProductEdit"}},[_c('ProductForm',{attrs:{"product":_vm.product,"submitForm":_vm.updateRow,"buttonText":"Actualizar","hasProduct":"true","hasLoadProduct":"true","hasValorID":_vm.product.pricelist_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }